import type { ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import { Text } from './Text.js';
import styles from './FieldStack.module.css';

export type FieldStackProps = {
  label: ReactNode;
  htmlFor?: string;
  hint?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  children: ReactNode;
  className?: string;
};

/** Label + hint + error wrapper for form controls. */
export function FieldStack({
  label,
  htmlFor,
  hint,
  error,
  required,
  children,
  className,
}: FieldStackProps) {
  return (
    <div className={cx(styles.stack, className)}>
      <label className={styles.label} htmlFor={htmlFor}>
        {label}
        {required ? (
          <span className={styles.required} aria-hidden>
            {' '}
            *
          </span>
        ) : null}
      </label>
      {children}
      {hint && !error ? (
        <Text size="xs" c="dimmed" component="div" className={styles.hint}>
          {hint}
        </Text>
      ) : null}
      {error ? (
        <Text size="xs" c="error" component="div" className={styles.error} role="alert">
          {error}
        </Text>
      ) : null}
    </div>
  );
}
